// extracted by mini-css-extract-plugin
export default {"info":"UfoFormInfo_info__E5QtZ","marginBottom":"UfoFormInfo_marginBottom__Ys8G7"};